export const PUSH = 'message/PUSH';
export const POP = 'company/POP';

const initialState = null;
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case PUSH:  return action.payload;
        case POP:  return initialState;
        default: return state;
    }
}